export default {
  title: 'Get these benefits when you use your card at %{merchant}',
  box: {
    item1: 'Free reward just for joining',
    item2: 'Automatic reward progress for each purchase',
    item3: 'No new cards to carry, use the card you already shop with',
  },
  button: 'Continue',
}
